import Http from '@/http/bhiotrack';
import { serialize } from '@/utils';

const createSubscription = async (data) => Http.post('/order', data);
const getSubscription = async (params = {}) => {
  return Http.get(`/order${serialize(params)}`);
};
const cancelSubscription = async (orderId) => Http.delete(`/order/${orderId}`);

const updateSubscription = async (orderId, data) => Http.put(`/order/${orderId}`, data);

export const subscriptionService = {
  createSubscription,
  getSubscription,
  cancelSubscription,
  updateSubscription,
};
